import moment from "moment";
import { LinkPaymentStatesController } from "../link-payment-states/link-payment-states.controller";
import { onlineT } from "../../../typings/online";
import { paymentT } from "../../../typings/payment";
import { LINK_PAYMENT_RELAUNCH_MIN } from "../../../thor.const";
import { Enums, Events } from "../../../thor.enums";
import { isManualPaymentEnabled } from "../../../utils/payment";

export class PaymentActionsController extends LinkPaymentStatesController {
    public static $inject: string[] = [
        "$element",
        "$log",
        "$mdDialog",
        "$mdMedia",
        "$rootScope",
        "$scope",
        "$translate",
        "linkPaymentService",
        "paymentService",
        "toaster"
    ];

    // Binded
    public containerEndDate: string;
    public containerId: number;
    public contractId: number;
    public getItems: Function;
    public itemId: number;
    public lastBidder: onlineT.LastBidder;
    public payments: paymentT.Payment[];
    public saleCurrency: Enums.Currency;
    public saleDepositAmount: number;
    public salePaymentDeposit: paymentT.Payment[];

    private $t;

    constructor(
        private $element: JQLite,
        private $log: ng.ILogService,
        private $mdDialog: ng.material.IDialogService,
        private $mdMedia: ng.material.IMedia,
        private $rootScope: ng.IRootScopeService,
        private $scope,
        $translate: ng.translate.ITranslateService,
        private linkPaymentService,
        protected paymentService,
        private toaster
    ) {
        super($scope, paymentService);

        this.$t = $translate.instant;

        $scope.isLinkItem = type => type === paymentT.thor.LinkPaymentStateType.ITEM;
        $scope.isManualPaymentEnabled = () => isManualPaymentEnabled(this.containerEndDate);
    }

    public $onInit() {
        angular.element(() => {
            const element = this.$element[0];
            const dropdown = element.querySelector(".dropdown-trigger");
            if (dropdown) {
                M.Dropdown?.init(dropdown, { constrainWidth: false });
            }
        });
    }

    public createLinkPayment(linkPaymentType: paymentT.thor.LinkPaymentStateType) {
        if (
            linkPaymentType === paymentT.thor.LinkPaymentStateType.DELIVERY &&
            !this.isLinkPaymentSuccess[this.linkPaymentStateTypeEnum.ITEM]
        ) {
            return this.$mdDialog.show(
                this.$mdDialog
                    .confirm()
                    .clickOutsideToClose(true)
                    .title(this.$t("create_link_payment_alert.error_confirm.title"))
                    .htmlContent(`<p>${this.$t("create_link_payment_alert.error_confirm.description")}</p>`)
                    .ok(this.$t("j_ai_compris"))
            );
        }

        this.$mdDialog.show({
            controller: "CreateLinkPaymentDialogController",
            controllerAs: "dialogCtrl",
            template: require("../../../shared/dialog/dialog-form.html"),
            locals: {
                containerId: this.containerId,
                contractId: this.contractId,
                items: this.getItems(),
                lastBidder: this.lastBidder,
                linkPaymentType,
                saleCurrency: this.saleCurrency,
                saleDepositAmount: this.saleDepositAmount,
                salePaymentDeposit: this.salePaymentDeposit
            },
            bindToController: true,
            fullscreen: this.$mdMedia("xs")
        });
    }

    public updateLinkPayment(linkPaymentType: paymentT.thor.LinkPaymentStateType) {
        const {
            id: linkPaymentId,
            created,
            has_expired: linkPaymentExpired,
            last_relaunched_date: lastRelaunchedDate
        } = this.findLinkPayment(linkPaymentType);

        // created date (or relaunched)
        const upsertDate = lastRelaunchedDate || created;

        this.$log.info("ID link_payment :", linkPaymentId);

        // Modal 1 : if-case link payment update not enabled (-7 days after created or relaunched)
        if (!this.isLinkPaymentUpdateEnabled[linkPaymentType]) {
            this.$mdDialog.show(
                this.$mdDialog
                    .confirm()
                    .multiple(true)
                    .clickOutsideToClose(true)
                    .htmlContent(
                        `<p>${this.$t(
                            this.$scope.isLinkItem(linkPaymentType)
                                ? "update_link_payment_alert.desc_1.item"
                                : "update_link_payment_alert.desc_1.delivery",
                            [moment(upsertDate).format("L")]
                        )}</p>
                        <p>${this.$t("update_link_payment_alert.desc_2", [
                            moment(upsertDate).add(LINK_PAYMENT_RELAUNCH_MIN, "days").format("L - LT")
                        ])}</p>
                        <p>${this.$t("update_link_payment_alert.desc_3", [
                            `${this.lastBidder.phone_mobile?.prefix || ""} ${
                                this.lastBidder.phone_mobile?.number || ""
                            }`
                        ])}</p>`
                    )
                    .cancel(this.$t("annuler"))
                    .ok(this.$t("j_ai_compris"))
            );
            return;
        }

        // Modal 2 : else-case link payment update enabled
        this.$mdDialog.show({
            controller: "UpdateLinkPaymentDialogController",
            controllerAs: "dialogCtrl",
            template: require("../../../shared/dialog/dialog-form.html"),
            locals: {
                containerId: this.containerId,
                items: this.getItems(),
                lastBidder: this.lastBidder,
                linkPaymentId,
                linkPaymentType,
                linkPaymentExpired
            },
            bindToController: true,
            fullscreen: this.$mdMedia("xs")
        });
    }

    public deleteLinkPayment(linkPaymentType: paymentT.thor.LinkPaymentStateType) {
        const { id: linkPaymentId } = this.findLinkPayment(linkPaymentType);
        const confirm = this.$mdDialog
            .confirm()
            .title(
                this.$t(
                    this.$scope.isLinkItem(linkPaymentType)
                        ? "delete_link_payment_alert.title.item"
                        : "delete_link_payment_alert.title.delivery"
                )
            )
            .htmlContent(`<p>${this.$t("delete_link_payment_alert.description")}</p>`)
            .ariaLabel(this.$t("delete_link_payment_alert.delete_confirmation"))
            .ok(this.$t("delete_link_payment_alert.ok"))
            .cancel(this.$t("annuler"));

        this.$mdDialog.show(confirm).then(() => {
            this.linkPaymentService
                .delete(this.containerId, linkPaymentId)
                .then(() => {
                    this.$rootScope.$emit(Events.OnlineSalePaymentsUpdated);

                    this.toaster.show(
                        this.$t(
                            this.$scope.isLinkItem(linkPaymentType)
                                ? "delete_link_payment_alert.success.item"
                                : "delete_link_payment_alert.success.delivery"
                        )
                    );
                })
                .catch((error: any) => {
                    this.$log.error("Unable to delete link payment : ", error);
                    this.toaster.toast(this.$t("delete_link_payment_alert.error"), true);
                });
        });
    }
}
